import axios from "axios";
import config from "config";
import storage from "libs/storage";
import { StatusCode } from "./constant";
import { get } from "lodash";
import { onIndentitySwitch } from "store/reducers/user";
import history from "libs/history";
import store from "store";
import detectWX from "libs/detectWX";
import detectBusinessWX from "libs/detectBusinessWX";
import hrtpsLog from "@hrtps/log";


const axiosInstance = axios.create({
  baseURL: config.API_URL,
  timeout: 90000,
  headers: { platform: "PC" },
});
// const refreshToken = async () => {
//   // todo 根据用户类型，请求不同的url
//   const res: Response<any> = await axiosInstance.get(
//     `${axios.defaults.baseURL}/common-auth-server/api/b/auth/token/refresh`
//   );
//   return res;
// };
// let isRefreshing = false;
// let requests: any[] = [];
// 处理responseType是blob类型的响应
const interceptorsResponse = (response: any) => {
  const contentType = "text/plain;charset=UTF-8";
  const responseType = "blob";
  const { data } = response;
  if (
    typeof response.request.responseType === "string" &&
    response.request.responseType.toLocaleLowerCase() === responseType
  ) {
    if (response.headers["content-type"] === contentType) {
      let reader: any = new FileReader();
      reader.readAsText(data);
      return new Promise((resolve) => {
        reader.onload = (e: any) => {
          resolve(JSON.parse(e.target.result));
        };
      });
    }
  }
  return data;
};
axiosInstance.interceptors.request.use(
  function (config) {
    const token = storage.getToken();
    hrtpsLog.info('axiosLog',  {
      'Access-Token': token,
      'COMPANY_ID': storage.getCompanyID(),
      'body': JSON.stringify(config.data),
      'reqUrl': config.url
    })
    if (token) {
      config.headers['access-token'] = token;
    }
    // if (token) {
      config.headers["business-platform"] = detectWX()
        ? "wechat"
        : detectBusinessWX()
        ? "wecom"
        : storage.getItem("login-method") === "takeda-teams"
        ? "teams"
        : "common";
    // }
    if (["/file/upload"].includes(config.url || "")) {
      config.timeout = 90000;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);
axiosInstance.interceptors.response.use(
  async function (response) {
    const { data } = response;
    const { code, success } = await interceptorsResponse(response);

    if (success && code === StatusCode.success) {
      return data;
    }

    if (code === StatusCode.expired) {
      // store.dispatch(toLoginPage({}));
      const goLogout = get(window, "goLogout");
      // @ts-ignore
      typeof goLogout === "function" && store.dispatch(goLogout({}));
    }

    if (
      code === StatusCode.staffToTourist ||
      code === StatusCode.touristToStaff
    ) {
      store.dispatch(onIndentitySwitch(data));
    }

    //   if (
    //     code === EnumStatus.staffToTourist ||
    //     code === EnumStatus.touristToStaff
    //   ) {
    //     dispatch({
    //       type: "global/setUserIdentity",
    //       payload: response.data,
    //     });
    //   }

    // if (code === ERROR_CODE.INVALID_TOKEN || code === ERROR_CODE.NEED_LOGIN) {
    //   // utils.goLogin();
    //   return data;
    // }
    // if (code === ERROR_CODE.TOKEN_EXPIRED) {
    //   const { config } = response;
    //   if (isRefreshing) {
    //     return new Promise((resolve) => {
    //       requests.push(() => {
    //         config.headers["x-header-token"] = storage.getToken();
    //         resolve(axiosInstance(config));
    //       });
    //     });
    //   } else {
    //     isRefreshing = true;
    //     const res = await refreshToken();
    //     const { data, success } = res;
    //     isRefreshing = false;
    //     if (success) {
    //       storage.setToken(data);
    //       requests.forEach((cb) => cb());
    //       requests = [];
    //       return axiosInstance(config);
    //     } else {
    //       // storage.logout();
    //       // utils.goLogin();
    //     }
    //     requests = [];
    //     return res;
    //   }
    // }
    if (success === false) {
      // let errorMessage = data.message;
      // message.error(errorMessage);
      return data;
    }
    return data;
  },
  function (error) {
    if (get(error, "message", "").indexOf("timeout") === -1) {
      const hash = window.location.hash;
      if (
        !hash.includes("/system-maintenance") &&
        get(window, "navigator.onLine")
      ) {
        history.replace("/system-maintenance");
      }
    }
    return {
      success: false,
    };
  }
);
export default axiosInstance;
